// extracted by mini-css-extract-plugin
module.exports = {"addToCart":"AddToCart_add-to-cart__PEWbH","addToCartLarge":"AddToCart_add-to-cart--large__FtFGv"};